module.exports = __webpack_public_path__ + "static/media/2-01.319142c7.png";